const _onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index
}

/**
 * @param array
 * @return Array
 */
export default (array) => {
    return !Array.isArray(array) ? [] : array.filter(_onlyUnique)
}
